import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbsiBuilderComponent } from './absi-builder/absi-builder.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule, FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOptionModule, ErrorStateMatcher } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxsModule } from '@ngxs/store';
import { QuillModule } from 'ngx-quill';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AppComponent } from 'src/app/app.component';
import { ControlsModule } from 'src/app/controls/controls.module';
import { httpInterceptorProviders } from 'src/app/common/interceptors/interceptorProviders';
import { SharedModule } from 'src/app/modules/shared.module';
import { reducers } from 'src/app/store/reducers';
import { ChecklistsModule } from '../checklists/checklists.module';
import { config } from 'src/assets/config';
import { AbsiBuilderSideComponent } from './absi-builder/absi-builder-side/absi-builder-side.component';
import { AbsiBuilderService } from './absi-builder/absi-builder.service';
import { AbsiBuilderMainComponent } from './absi-builder/absi-builder-main/absi-builder-main.component';
import { AbsiBuilderButtonsComponent } from './absi-builder/absi-builder-buttons/absi-builder-buttons.component';
import { AbsiBuilderSectionComponent } from './absi-builder/absi-builder-main/absi-builder-section/absi-builder-section.component';
import { AbsiComponent } from './absi.component';
import { AbsiService } from './absi.service';
import { AbsiSidePanelComponent } from './absi-side-panel/absi-side-panel.component';
import { AbsiMainPanelComponent } from './absi-main-panel/absi-main-panel.component';
import { CatlReportComponent } from 'src/app/controls/catl/catl-report/catl-report.component';
import { AbsiSectionXComponent } from './absi-main-panel/absi-section-wrapper/absi-section-x/absi-section-x.component';
import { AbsiSectionWrapperComponent } from './absi-main-panel/absi-section-wrapper/absi-section-wrapper.component';
import { AbsiSectionSignatureComponent } from './absi-main-panel/absi-section-wrapper/absi-section-signature/absi-section-signature.component';
import { AbsiReviewAndConcurrenceComponent } from './absi-main-panel/absi-review-and-concurrence/absi-review-and-concurrence.component';


const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline'
};

class TouchedErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

@NgModule({
  declarations: [
    AbsiBuilderComponent,
    AbsiBuilderSideComponent,
    AbsiBuilderMainComponent,
    AbsiBuilderButtonsComponent,
    AbsiBuilderSectionComponent,

    AbsiComponent,
    AbsiSidePanelComponent,
    AbsiMainPanelComponent,
    AbsiSectionWrapperComponent,
    AbsiSectionSignatureComponent,
    AbsiSectionXComponent,
    AbsiReviewAndConcurrenceComponent,

    CatlReportComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatButtonModule,
    MatDialogModule,
    HttpClientModule,
    ScrollingModule,
    HttpClientModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatChipsModule,
    MatIconModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatRadioModule,
    MatStepperModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatTooltipModule,
    MatGridListModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    DragDropModule,
    MatTreeModule,
    MatExpansionModule,
    MatOptionModule,
    MatSidenavModule,
    MatTooltipModule,
    QuillModule.forRoot(),
    SharedModule,
    ControlsModule,
    ChecklistsModule
  ],
  exports: [
    RouterModule,
  ],
  providers: [
    AbsiService,
    AbsiBuilderService,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: appearance
    },
    httpInterceptorProviders,
    { provide: ErrorStateMatcher, useClass: TouchedErrorStateMatcher }
  ],
  bootstrap: [AppComponent, SharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AbsiModule { }
